import { Divider, Stack, TextField, Checkbox, FormControlLabel } from '@mui/material';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Icon } from '@iconify/react';

import FilterSelector from './FilterSelector';
import FilterSelectorAttributes from './FilterSelectorAttributes';
import { Box } from '@mui/system';
import { FoundContext } from 'src/pages/Products';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { getCategories } from 'src/service/categoriesApi';

export default function AnnonceSelector({ customerId }) {
  const {
    selectedCategory,
    setSelectedCategory,
    filteredAttributes,
    setFilteredAttributes,
    setDate,
    numObject,
    setNumObject,
    globalValue,
    setGlobalValue,
    onlyWithConversations,
    setOnlyWithConversations,
  } = useContext(FoundContext);
  const [categories, setCategories] = useState([]);
  const [dateSelected, setDateSelected] = useState(new Date());

  const handleChangeDate = (newDate) => {
    setDate(newDate);
    setDateSelected(newDate);
  };

  const handleResetDate = () => {
    setDate(false);
  };

  useEffect(() => {
    let isMounted = true;
    
    getCategories().then((resp) => {
      if (isMounted) {
        setCategories(resp);
      }
    });
    
    return () => {
      isMounted = false;
    };
  }, []);

  const day = new Date();
  const [alignment, setAlignment] = useState('web');
  const filteredCategory = selectedCategory ? categories.filter((a) => a.id === selectedCategory) : null;
  const handleChangeDay = (event, newAlignment) => {
    if (event.target.value === 'reset') {
      handleResetDate();
      setAlignment(newAlignment);
    } else {
      day.setDate(day.getDate() - event.target.value);
      setAlignment(newAlignment);
      setDate(day);
    }
  };
  return (
    <Box>
      <Stack mb={2}>
          <TextField
            label="Recherche Globale"
            value={globalValue || ''}
            onChange={(event) => setGlobalValue(event.target.value)}
          />
      </Stack>
      <Stack sx={{ flexDirection: { sm: 'column', md: 'row' }, gap: "10px" }} spacing={2} mb={2}>
        <Box sx={{ position: 'relative', flex: 1 }}>
          <TextField
            label="Numero d'objet"
            value={numObject || ''}
            onChange={(e) => {
              setNumObject(e.target.value);
            }}
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                backgroundColor: numObject && numObject.trim() !== '' ? '#fff3cd' : 'transparent',
                borderColor: numObject && numObject.trim() !== '' ? '#ffc107' : undefined,
                '&:hover': {
                  backgroundColor: numObject && numObject.trim() !== '' ? '#ffeaa7' : undefined,
                },
                '&.Mui-focused': {
                  backgroundColor: numObject && numObject.trim() !== '' ? '#fff3cd' : undefined,
                  borderColor: numObject && numObject.trim() !== '' ? '#ffc107' : undefined,
                }
              },
              '& .MuiInputLabel-root': {
                color: numObject && numObject.trim() !== '' ? '#856404' : undefined,
                fontWeight: numObject && numObject.trim() !== '' ? '600' : 'normal',
              }
            }}
            InputProps={{
              endAdornment: numObject && numObject.trim() !== '' ? (
                <Box
                  sx={{
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '4px',
                    borderRadius: '50%',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                    }
                  }}
                  onClick={() => setNumObject('')}
                  title="Effacer le numéro d'objet"
                >
                  <Icon icon="eva:close-fill" width={18} height={18} color="#666" />
                </Box>
              ) : null,
            }}
          />
        </Box>
        {/*<TextField
          label="email"
          onChange={(e) => {
            setEmail(e.target.value);
          }}
          sx={{ marginTop: "0 !important" }}
        />
        <TextField
          label="Nom"
          onChange={(e) => {
            setName(e.target.value);
          }}
          sx={{ marginTop: "0 !important" }}
        />*/}
      </Stack>

      <Stack sx={{ flexDirection: { sm: 'column', md: 'row' } }} spacing={2} mb={2}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            label="Quand ?"
            inputFormat="dd/MM/yyyy"
            value={dateSelected}
            onChange={(newDate) => {
              handleChangeDate(newDate);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>

        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center',
          width: '100%',
          py: 1,
        }}>
          <ToggleButtonGroup
            sx={{ 
              size: { xs: 'small', md: 'medium' },
              width: { xs: '100%', md: 'auto' },
              '& .MuiToggleButton-root': {
                fontSize: { xs: '0.65rem', sm: '0.75rem', md: '0.875rem' },
                padding: { xs: '4px 6px', sm: '6px 12px', md: '8px 16px' },
                minWidth: { xs: 'auto', md: '64px' },
                flex: { xs: '1 1 auto', md: 'none' },
                whiteSpace: 'nowrap',
              }
            }}
            color="primary"
            value={alignment}
            exclusive
            onChange={handleChangeDay}
          >
            <ToggleButton variant="contained" value={0}>
              Aujourd'hui
            </ToggleButton>
            <ToggleButton value={1}>Hier</ToggleButton>
            <ToggleButton value={2}>Avant-hier</ToggleButton>
            <ToggleButton value={3}>3 jours</ToggleButton>
            <ToggleButton value="reset">Toutes</ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </Stack>
      <Box
        sx={{
          marginBottom: '20px',
          display: 'flex',
          flexDirection: 'column',
          height: 'auto',
          width: '100%',
        }}
      >
        {' '}
        <Divider />
        <Stack sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' }, mr: "5px", alignItems: 'center' }}>
                    <FilterSelector
            label="Catégories"
            selectedValue={selectedCategory}
            setSelectedValue={setSelectedCategory}
            dataFilters={categories}
            setFilteredAttributes={setFilteredAttributes}
            filteredAttributes={filteredAttributes}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={onlyWithConversations}
                onChange={e => setOnlyWithConversations(e.target.checked)}
                color="primary"
                sx={{
                  '&.Mui-checked': {
                    color: '#1976d2',
                  },
                  '&:hover': {
                    backgroundColor: 'rgba(25, 118, 210, 0.08)',
                  },
                  borderRadius: 2,
                  boxShadow: onlyWithConversations ? '0 0 0 2px #1976d2' : 'none',
                  transition: 'box-shadow 0.2s',
                }}
                icon={<span style={{
                  borderRadius: 6,
                  width: 22,
                  height: 22,
                  background: '#fff',
                  border: '1.5px solid #bdbdbd',
                  display: 'block'
                }} />}
                checkedIcon={<span style={{
                  borderRadius: 6,
                  width: 22,
                  height: 22,
                  background: '#1976d2',
                  border: '1.5px solid #1976d2',
                  display: 'block',
                  position: 'relative'
                }}>
                  <svg width="16" height="16" style={{ position: 'absolute', top: 3, left: 3 }} viewBox="0 0 16 16">
                    <polyline points="3.5 8.5 7 12 13 5" style={{ fill: 'none', stroke: '#fff', strokeWidth: 2 }} />
                  </svg>
                </span>}
              />
            }
            label={
              <span style={{
                fontWeight: 600,
                fontSize: '1rem',
                color: onlyWithConversations ? '#1976d2' : '#333',
                letterSpacing: 0.2
              }}>
                Avec conversations
              </span>
            }
            sx={{ ml: 2 }}
          />
          <Stack sx={{ flexDirection: { xs: 'column', sm: 'column', md: 'row' }, marginTop: 0 }}>
            {filteredCategory &&
              filteredCategory.map((data, categoryIndex) => {
                return (
                  <Fragment key={`category-${categoryIndex}`}>
                    {data.attribute.map((attribute, attributeIndex) => {
                      return attribute.isSecret !== true ? (
                        <FilterSelectorAttributes
                          key={`attribute-${categoryIndex}-${attributeIndex}`}
                          filteredAttributes={filteredAttributes}
                          setFilteredAttributes={setFilteredAttributes}
                          label={attribute.name}
                          dataFilters={attribute.attributes}
                          ui={attribute.ui}
                          uiLabel={attribute.uiLabel}
                        />
                      ) : null;
                    })}
                  </Fragment>
                );
              })}
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
}
